import { useCallback } from 'react';
import { doc, getDoc, setDoc, updateDoc } from 'firebase/firestore';
import { db } from '../../firebase-config';


const useAddAccordion = (companyId, selectedYear, setQuarters) => {
    const addAccordion = useCallback(async (quarterKey) => {
        const titleTimeStamp = new Date().getTime();
        const newAccordion = { 
            title: `Nyt Mål ${titleTimeStamp}`, 
            content: 'New Content',
            timeStamp: new Date().toISOString(), 
            status: 'To-Do', 
            isFinished: false
        };
        const yearDocRef = doc(db, `companies/${companyId}/accordions/YearSelect/years/${selectedYear}`);
        const docSnapshot = await getDoc(yearDocRef);

        if (!docSnapshot.exists()) {
            
            await setDoc(yearDocRef, {
                [quarterKey]: [newAccordion]  
            });
            
            setQuarters(prev => ({
                ...prev,
                [quarterKey]: [newAccordion]
            }));
        } else {
            
            let quartersData = docSnapshot.data();
            let updatedQuarters = { ...quartersData };
            updatedQuarters[quarterKey] = updatedQuarters[quarterKey] ? [...updatedQuarters[quarterKey], newAccordion] : [newAccordion];

            await updateDoc(yearDocRef, updatedQuarters);
            setQuarters(prev => ({
                ...prev,
                [quarterKey]: updatedQuarters[quarterKey]
            }));
        }
    }, [companyId, selectedYear, setQuarters]);

    return addAccordion;
};

export default useAddAccordion;